<template>
  <div ref="scale" v-if="row">
    <h2 class="mb-5 mt-10">{{ title }}</h2>
    <div class="scale">
      <div>-3</div>
      <div>-2</div>
      <div>-1</div>
      <div>0</div>
      <div>1</div>
      <div>2</div>
      <div>3</div>
    </div>
    <div class="scores" v-for="(row, index) in reducedData" :key="`r${index}`">
      <p class="subtitle-1">{{ getFromLabel(index) }}</p>
      <div v-for="(item, innerIndex) in row" :key="`s${innerIndex}`">
        <div class="score" :style="getStyle(item.score, item.count, row)">
          <v-chip color="white" class="black--text">{{ item.count }}</v-chip>
        </div>
      </div>
      <p class="subtitle-1">{{ getToLabel(index) }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResultsScale",
  data() {
    return {
      unit: 0,
      data: null,
      all: null,
      debug: false,
      maxSize: 100,
      reducedData: null,
    };
  },
  components: {},
  props: {
    row: Array,
    title: String,
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let bounding = this.$refs.scale.getBoundingClientRect();
      this.unit = bounding.width / 7;
      this.$nextTick(() => {
        this.createData();
      });
    },
    plot(point) {
      // Center point + point
      let midUnit = this.unit / 2;
      let centerPoint = this.unit * 3 + midUnit;
      return centerPoint + point * this.unit;
    },
    radius(score) {
      let max = this.getMax(this.all);
      let unit = this.maxSize / max + 20;
      return score * unit;
    },
    createData() {
      // loop through all responses in the exercise
      // group all row1, row2 etc together
      let arr = {};
      this.row.forEach((x) => {
        // split the data up into the exercises
        Object.keys(x).forEach((key) => {
          let filtered = this.row.map((item) => item[key]);
          arr[key] = filtered;
        });
      });
      this.data = arr;
      this.reduceRows();
    },
    reduceRows() {
      let items = {};
      let scores = [];
      Object.entries(this.data).forEach(([key, value]) => {
        let inner = [];
        let distribution = Object.values(value).reduce(
          (acum, cur) => Object.assign(acum, { [cur]: (acum[cur] | 0) + 1 }),
          {}
        );
        for (var element in distribution) {
          inner.push({ score: element, count: distribution[element] });
        }
        items[key] = inner;
        scores.push(distribution[element]);
      });
      // ordering rows
      const ordered = Object.keys(items)
        .sort()
        .reduce((obj, key) => {
          obj[key] = items[key];
          return obj;
        }, {});
      //
      this.reducedData = ordered;
      // this.reducedData = items;
      this.allScores();
    },
    allScores() {
      let scores = [];
      Object.values(this.reducedData).forEach((x) => {
        Object.values(x).forEach((y) => {
          scores.push(y.count);
        });
      });
      this.all = scores;
    },
    getMax(arr) {
      return (this.max = Math.max.apply(null, arr));
    },
    getFromLabel(index) {
      switch (index) {
        case "row1":
          return "Funny";
        case "row2":
          return "Formal";
        case "row3":
          return "Respectful";
        case "row4":
          return "Enthusiastic";
      }
    },
    getToLabel(index) {
      switch (index) {
        case "row1":
          return "Serious";
        case "row2":
          return "Casual";
        case "row3":
          return "Irreverent";
        case "row4":
          return "Matter of fact";
      }
    },
    getColor(index) {
      // let colors = ['#FF5722','#FF9800','#FFC107','#FFEB3B','#CDDC39','#8BC34A','#4CAF50','#009688','#26C6DA','#03A9F4','#3F51B5','#673AB7','#9C27B0','#E91E63','#EF5350'];
      let colors = [
        "#FF5722",
        "#FFC107",
        "#CDDC39",
        "#8BC34A",
        "#009688",
        "#03A9F4",
        "#673AB7",
        "#3F51B5",
        "#9C27B0",
        "#E91E63",
        "#EF5350",
      ];
      let picker = colors.length - 1 - index;
      return colors[picker];
    },
    getStyle(point, score) {
      return {
        top: "50%",
        left: `${this.plot(point)}px`,
        width: `${this.radius(score)}px`,
        height: `${this.radius(score)}px`,
        color: this.getColor(score),
        borderColoor: this.getColor(score),
      };
    },
  },
};
</script>

<style lang="scss">
.scale {
  display: flex;
  // border: 1px solid red;
  justify-content: space-around;
}
.scores {
  width: 100%;
  background: rgba(255, 255, 255, 0.2);
  background: linear-gradient(
    0deg,
    rgba(80, 80, 80, 0.5340511204481793) 0%,
    rgba(79, 79, 79, 0) 100%
  );
  // height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.5rem;
  position: relative;
  // border: 1px solid white;
  height: 230px;
  p {
    z-index: 99;
  }
  .score {
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    border-radius: 50%;
    // background: white;
    background: rgba(255, 255, 255, 0.2);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(-50%, -50%);
    opacity: 1;
    // border: none;

    .v-chip {
      background: none !important;
      color: white !important;
    }
  }
}
</style>
